// extracted by mini-css-extract-plugin
export default {"tab__container":"styles_tab__container__hY-YA","tab__item":"styles_tab__item__piITM","tab__text":"styles_tab__text__YQxPF","tab__item--actived":"styles_tab__item--actived__uyiy2"};